module Meevo.Plugins.Memberships {


    import Membership = Meevo.Model.Membership;
    import AutoRenewTypeEnum = Meevo.Model.AutoRenewTypeEnum;
    import RecurringPaymentScheduleEnum = Meevo.Model.RecurringPaymentScheduleEnum;
    import BillingTypeEnum = Meevo.Model.BillingTypeEnum;
    import MembershipLengthEnum = Meevo.Model.MembershipLengthEnum;

    enum SelectedMembershipLengthEnum {
        One = 1,
        TwoToFive = 2,
        Six = 3,
        SevenToEleven = 4,
        TwelveToTwentyThree = 5,
        TwentyFourAndHigher = 6
    }

    interface ISelectOption {
        label: string;
        value: any;
    }

    interface IBillingSettingsScope extends ng.IScope {

    }

    const LENGTH_TYPES: ISelectOption[] = [
        {label: 'LABEL_MONTH(S)', value: MembershipLengthEnum.Months},
        {label: 'LABEL_DAY(S)', value: MembershipLengthEnum.Days}
    ];

    const BILLING_TYPES: ISelectOption[] = [
        {label: 'LABEL_PAID_IN_FULL', value: BillingTypeEnum.PaidInFull},
        {label: 'LABEL_RECURRING_PAYMENTS', value: BillingTypeEnum.RecurringPayments}
    ];

    const RECURRING_PAYMENTS_SCHEDULE: ISelectOption[] = [
        {label: 'LABEL_MONTHLY', value: RecurringPaymentScheduleEnum.Monthly},
        {label: 'LABEL_QUARTERLY', value: RecurringPaymentScheduleEnum.Quarterly},
        {label: 'LABEL_SIX_MONTH', value: RecurringPaymentScheduleEnum.SixMonths},
        {label: 'LABEL_YEARLY', value: RecurringPaymentScheduleEnum.Yearly},
    ];

    const AUTO_RENEW: ISelectOption[] = [
        // {label: 'LABEL_NO', value: AutoRenewTypeEnum.No},
        {label: 'LABEL_PAID_IN_FULL', value: AutoRenewTypeEnum.PaidInFull},
        {label: 'LABEL_MONTHLY', value: AutoRenewTypeEnum.Monthly},
        {label: 'LABEL_BOTH', value: AutoRenewTypeEnum.Both},
    ];

    interface IDataSet {
        billingTypes: ISelectOption[];
        recurringPaymentsSchedule: ISelectOption[];
        autoRenew: ISelectOption[];
    }

    class BillingSettingsDataSets {

        public defaultDataSet: IDataSet;

        private dataSets: { [key: number]: IDataSet } = {};
        private model: Membership;

        constructor(model: Membership) {
            this.model = model;

            this.defaultDataSet = Object.defineProperties({}, {
                billingTypes: {
                    get: () => (this.model.membershipLengthEnum === MembershipLengthEnum.Days) || (this.model.membershipLengthEnum === MembershipLengthEnum.Months && this.model.membershipLength === 1)
                        ? BILLING_TYPES.filter(o => o.value !== BillingTypeEnum.RecurringPayments)
                        : BILLING_TYPES
                },
                autoRenew: {get: () => AUTO_RENEW},
                recurringPaymentsSchedule: {get: () => RECURRING_PAYMENTS_SCHEDULE},
            });

            this.fillDataSets();
        }

        /**
         * Populate a dataSets object
         */
        private fillDataSets() {
            let baseObj = {
                autoRenew: {
                    get: () => {
                        let autoRenewData = AUTO_RENEW;

                        if (this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                            autoRenewData = AUTO_RENEW.filter(o => [AutoRenewTypeEnum.Monthly].indexOf(o.value) !== -1);
                        } else if (this.model.billingTypeEnum === this.model['previousBillingTypeEnum'] && this.model['previousAutoRenewTypeEnum'] !== AutoRenewTypeEnum.No) {
                            if (this.model.autoRenewTypeEnum === AutoRenewTypeEnum.Both) {
                               autoRenewData = AUTO_RENEW;
                            } else {
                               autoRenewData = AUTO_RENEW.filter(o => this.model.autoRenewTypeEnum === o.value || o.value === AutoRenewTypeEnum.Both);
                            }                            
                        }

                        return autoRenewData;
                    }
                },
                billingTypes: {
                    get: () => BILLING_TYPES
                }
            };

            this.dataSets[SelectedMembershipLengthEnum.One] = {
                billingTypes: [],
                autoRenew: AUTO_RENEW.filter(o => [AutoRenewTypeEnum.Monthly].indexOf(o.value) !== -1),
                recurringPaymentsSchedule: [],
            };

            this.dataSets[SelectedMembershipLengthEnum.TwoToFive] = Object.defineProperties({}, _.extend({}, baseObj, {
                    recurringPaymentsSchedule: {
                        get: () => {
                            if (this.model.billingTypeEnum === BillingTypeEnum.PaidInFull) {
                                return [];
                            } else if (this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                                return RECURRING_PAYMENTS_SCHEDULE.filter(o => o.value === RecurringPaymentScheduleEnum.Monthly)
                            }

                            return RECURRING_PAYMENTS_SCHEDULE
                        }
                    }
                })
            );

            this.dataSets[SelectedMembershipLengthEnum.Six] = Object.defineProperties({}, _.extend({}, baseObj, {
                    recurringPaymentsSchedule: {
                        get: () => {
                            if (this.model.billingTypeEnum === BillingTypeEnum.PaidInFull) {
                                return [];
                            } else if (this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                                return RECURRING_PAYMENTS_SCHEDULE
                                    .filter(o => [
                                        RecurringPaymentScheduleEnum.Monthly,
                                        RecurringPaymentScheduleEnum.Quarterly
                                    ].indexOf(o.value) !== -1)
                            }

                            return RECURRING_PAYMENTS_SCHEDULE
                        }
                    }
                })
            );

            this.dataSets[SelectedMembershipLengthEnum.SevenToEleven] = Object.defineProperties({}, _.extend({}, baseObj, {
                    recurringPaymentsSchedule: {
                        get: () => {
                            if (this.model.billingTypeEnum === BillingTypeEnum.PaidInFull) {
                                return [];
                            } else if (this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                                return RECURRING_PAYMENTS_SCHEDULE
                                    .filter(o => [
                                        RecurringPaymentScheduleEnum.Monthly
                                    ].indexOf(o.value) !== -1)
                            }

                            return RECURRING_PAYMENTS_SCHEDULE;
                        }
                    }
                })
            );

            this.dataSets[SelectedMembershipLengthEnum.TwelveToTwentyThree] = Object.defineProperties({}, _.extend({}, baseObj, {
                    recurringPaymentsSchedule: {
                        get: () => {
                            if (this.model.billingTypeEnum === BillingTypeEnum.PaidInFull) {
                                return [];
                            } else if (this.model.billingTypeEnum === BillingTypeEnum.RecurringPayments) {
                                return RECURRING_PAYMENTS_SCHEDULE
                                    .filter(o => [
                                        RecurringPaymentScheduleEnum.Monthly,
                                        RecurringPaymentScheduleEnum.Quarterly,
                                        RecurringPaymentScheduleEnum.SixMonths
                                    ].indexOf(o.value) !== -1)
                            }

                            return RECURRING_PAYMENTS_SCHEDULE;
                        }
                    }
                })
            );

            this.dataSets[SelectedMembershipLengthEnum.TwentyFourAndHigher] = Object.defineProperties({}, _.extend({}, baseObj, {
                    recurringPaymentsSchedule: {
                        get: () => this.model.billingTypeEnum === BillingTypeEnum.PaidInFull ? [] : RECURRING_PAYMENTS_SCHEDULE
                    }
                })
            );
        }

        /**
         * Return a selected dataSet according to the selected membership length
         * @param {Meevo.Plugins.Memberships.SelectedMembershipLengthEnum} setEnum
         * @returns {Meevo.Plugins.Memberships.IDataSet}
         */
        public getDataSet(setEnum: SelectedMembershipLengthEnum): IDataSet {
            // we don't have any changes if the Days type selected
            if (this.model.membershipLengthEnum === MembershipLengthEnum.Days) {
                return this.defaultDataSet;
            }

            return this.dataSets[setEnum];
        }
    }

    class MeevoMembershipBillingSettingsComponent implements ng.IComponentController {

        static $inject = [
            '$scope'
        ];

        public model: Membership;
        public disabled: boolean;

        public billingSettingsDataSets: BillingSettingsDataSets;
        public dataSet: IDataSet;
        public isAllowAutoRenewTypeEnum: boolean;

        get lengthTypes() {
            return LENGTH_TYPES;
        }

        get billingTypeEnum() {
            return BillingTypeEnum;
        }

        get recurringPaymentScheduleEnum() {
            return RecurringPaymentScheduleEnum;
        }

        get autoRenewTypeEnum() {
            return AutoRenewTypeEnum;
        }

        get membershipLengthEnum() {
            return MembershipLengthEnum;
        }

        get selectedMembershipLengthEnum() {
            return SelectedMembershipLengthEnum;
        }

        get selectedMembershipCount(): SelectedMembershipLengthEnum | null {
            if (!this.model) {
                return null;
            } else if (this.model.membershipLength === 1) {
                return SelectedMembershipLengthEnum.One;
            } else if (this.model.membershipLength > 1 && this.model.membershipLength < 6) {
                return SelectedMembershipLengthEnum.TwoToFive;
            } else if (this.model.membershipLength === 6) {
                return SelectedMembershipLengthEnum.Six;
            } else if (this.model.membershipLength > 6 && this.model.membershipLength < 12) {
                return SelectedMembershipLengthEnum.SevenToEleven;
            } else if (this.model.membershipLength > 11 && this.model.membershipLength < 24) {
                return SelectedMembershipLengthEnum.TwelveToTwentyThree;
            } else if (this.model.membershipLength > 23) {
                return SelectedMembershipLengthEnum.TwentyFourAndHigher;
            } else {
                return null;
            }
        }

        constructor(private $scope: IBillingSettingsScope) {
            this.dataSet = {
                billingTypes: BILLING_TYPES,
                autoRenew: AUTO_RENEW,
                recurringPaymentsSchedule: RECURRING_PAYMENTS_SCHEDULE
            };
        }

        $onInit() {
            if (this.model) {
                this.model['previousBillingTypeEnum'] = this.model.billingTypeEnum;
                this.model['previousAutoRenewTypeEnum'] = this.model.autoRenewTypeEnum;
            }

            this.$scope.$watch(() => this.selectedMembershipCount, (newValue, oldValue) => {
                if (!!newValue && newValue !== oldValue && this.billingSettingsDataSets instanceof BillingSettingsDataSets) {
                    if (this.model.membershipLengthEnum === this.membershipLengthEnum.Months && this.model.membershipLength === 1) {
                        this.model.billingTypeEnum = BillingTypeEnum.PaidInFull;
                        this.updateBillingTypeDependencies();
                        this.changedIsAllowAutoRenewTypeEnum();
                    }
                    this.dataSet = this.billingSettingsDataSets.getDataSet(this.selectedMembershipCount);
                }
            });

            this.$scope.$watch(() => this.model ? this.model.membershipLengthEnum : null, (value) => {
                if (!!value && this.billingSettingsDataSets instanceof BillingSettingsDataSets) {
                    this.dataSet = this.billingSettingsDataSets.getDataSet(this.selectedMembershipCount);

                    if (value === this.membershipLengthEnum.Days) {
                        this.model.billingTypeEnum = BillingTypeEnum.PaidInFull;
                        this.model.recurringPaymentScheduleEnum = null;
                        this.updateBillingTypeDependencies();
                        this.isAllowAutoRenewTypeEnum = false;

                    } else if (value === this.membershipLengthEnum.Months) {
                        if (this.model.membershipLength === 1) {
                            this.model.billingTypeEnum = BillingTypeEnum.PaidInFull;
                            this.updateBillingTypeDependencies();
                        }
                        this.isAllowAutoRenewTypeEnum = true;
                    }
                    this.changedIsAllowAutoRenewTypeEnum();
                }
            });

            this.$scope.$watch(() => this.model, () => {
                this.billingSettingsDataSets = new BillingSettingsDataSets(this.model);
                this.dataSet = this.billingSettingsDataSets.getDataSet(this.selectedMembershipCount);
            });

            if (this.model && this.model.autoRenewTypeEnum !== AutoRenewTypeEnum.No) {
                this.isAllowAutoRenewTypeEnum = true;
            }
        }

        /**
         * Listen changes of auto renew and update other dependencies in model
         * */
        public updateAutoRenewDependencies(): void {
            const art = this.model.autoRenewTypeEnum;

            switch (art) {
                case AutoRenewTypeEnum.No:
                case AutoRenewTypeEnum.PaidInFull:
                case AutoRenewTypeEnum.Monthly:
                    _.each(this.model.membershipMemberSettings, (item) => {
                        item.pifRenewalFee = 0;
                        item.minPIFRenewalFee = 0;
                        item.monthlyRenewalFee = 0;
                        item.minMonthlyRenewalFee = 0;
                    });
                    break;
            }
        }


        /**
         * Listen changes of membership length and update billing type accordingly
         * */
        public updateBillingType(): void {
            const ml = this.model.membershipLengthEnum;

            switch (ml) {
                case MembershipLengthEnum.Months:
                    this.model.billingTypeEnum = BillingTypeEnum.RecurringPayments;
                    this.model.autoRenewTypeEnum = AutoRenewTypeEnum.Monthly;
                    if (!this.model.recurringPaymentScheduleEnum) {
                        this.model.recurringPaymentScheduleEnum = RecurringPaymentScheduleEnum.Monthly;
                    }
                    break;
                case MembershipLengthEnum.Days:
                    this.model.billingTypeEnum = BillingTypeEnum.PaidInFull;
                    this.model.autoRenewTypeEnum = AutoRenewTypeEnum.No;
                    this.model.recurringPaymentScheduleEnum = null;
                    break;
            }
        }

        /**
         * Listen changes of billing type and update other dependencies in model
         * */
        public updateBillingTypeDependencies(): void {
            const bt = this.model.billingTypeEnum;

            switch (bt) {
                case BillingTypeEnum.Manual:
                case BillingTypeEnum.RecurringPayments:
                    if (!this.model.recurringPaymentScheduleEnum) {
                        this.model.recurringPaymentScheduleEnum = RecurringPaymentScheduleEnum.Monthly;
                    }

                    this.isAllowAutoRenewTypeEnum = true;
                    this.changedIsAllowAutoRenewTypeEnum();
                    break;
                case BillingTypeEnum.PaidInFull:
                    this.model.recurringPaymentScheduleEnum = null;

                    if (this.model.autoRenewTypeEnum === AutoRenewTypeEnum.No) {
                        this.isAllowAutoRenewTypeEnum = true;
                        this.changedIsAllowAutoRenewTypeEnum();
                    }

                    _.each(this.model.membershipMemberSettings, (item) => {
                        item.recurringFee = 0;
                        item.minRecurringFee = 0;
                        item.billNumberOfDaysAfterEnroll = 31;
                    });
                    _.each(this.model.membershipFreezeSettings, (item) => {
                        item.fee = 0;
                    });
                    break;
            }
        }

        public changedIsAllowAutoRenewTypeEnum() {
            if (!this.isAllowAutoRenewTypeEnum) {
                this.model.autoRenewTypeEnum = AutoRenewTypeEnum.No;
            } else if (this.isAllowAutoRenewTypeEnum && this.model.billingTypeEnum === BillingTypeEnum.PaidInFull && this.model.membershipLength > 1) {
                this.model.autoRenewTypeEnum = AutoRenewTypeEnum.Both;
            } else if (this.isAllowAutoRenewTypeEnum) {
                this.model.autoRenewTypeEnum = AutoRenewTypeEnum.Monthly;
            }

            this.updateAutoRenewDependencies();
        }
    }

    angular.module('meevo.plugins.memberships')
        .component('meevoMembershipBillingSettingsComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/memberships/components/membership-billing-settings/membership-billing-settings.component.html',
            controller: MeevoMembershipBillingSettingsComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '<',
                disabled: '<'
            }
        });
}